export class PostPone {
    static $inject: string[] = ['item'];
    item: string;
    constructor(item: string) {
        this.item = item;
    }  
}
